// extracted by mini-css-extract-plugin
export default {"text-area":"JVZgK","text-area_withSide":"K0RH1","text-area__field":"eoPbw","text-area__field_withSide":"aCBRz","text-area__side":"kAkGs"};